export default __webpack_public_path__ + "static/TB-trusted-on-transparent-light-bg-111bfd64ca6a94ea653b9d330ca1ca27.svg";